/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SimpleDataRequestResource } from './SimpleDataRequestResource';
import {
    SimpleDataRequestResourceFromJSON,
    SimpleDataRequestResourceFromJSONTyped,
    SimpleDataRequestResourceToJSON,
    SimpleDataRequestResourceToJSONTyped,
} from './SimpleDataRequestResource';
import type { Resolution } from './Resolution';
import {
    ResolutionFromJSON,
    ResolutionFromJSONTyped,
    ResolutionToJSON,
    ResolutionToJSONTyped,
} from './Resolution';

/**
 * 
 * @export
 * @interface WindroseDataRequest
 */
export interface WindroseDataRequest {
    /**
     * 
     * @type {number}
     * @memberof WindroseDataRequest
     */
    timeFrom: number;
    /**
     * 
     * @type {number}
     * @memberof WindroseDataRequest
     */
    timeTo: number;
    /**
     * 
     * @type {Resolution}
     * @memberof WindroseDataRequest
     */
    resolution: Resolution;
    /**
     * 
     * @type {number}
     * @memberof WindroseDataRequest
     */
    buckets: number;
    /**
     * 
     * @type {Array<SimpleDataRequestResource>}
     * @memberof WindroseDataRequest
     */
    resources: Array<SimpleDataRequestResource>;
}



/**
 * Check if a given object implements the WindroseDataRequest interface.
 */
export function instanceOfWindroseDataRequest(value: object): value is WindroseDataRequest {
    if (!('timeFrom' in value) || value['timeFrom'] === undefined) return false;
    if (!('timeTo' in value) || value['timeTo'] === undefined) return false;
    if (!('resolution' in value) || value['resolution'] === undefined) return false;
    if (!('buckets' in value) || value['buckets'] === undefined) return false;
    if (!('resources' in value) || value['resources'] === undefined) return false;
    return true;
}

export function WindroseDataRequestFromJSON(json: any): WindroseDataRequest {
    return WindroseDataRequestFromJSONTyped(json, false);
}

export function WindroseDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WindroseDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'timeFrom': json['timeFrom'],
        'timeTo': json['timeTo'],
        'resolution': ResolutionFromJSON(json['resolution']),
        'buckets': json['buckets'],
        'resources': ((json['resources'] as Array<any>).map(SimpleDataRequestResourceFromJSON)),
    };
}

export function WindroseDataRequestToJSON(json: any): WindroseDataRequest {
    return WindroseDataRequestToJSONTyped(json, false);
}

export function WindroseDataRequestToJSONTyped(value?: WindroseDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timeFrom': value['timeFrom'],
        'timeTo': value['timeTo'],
        'resolution': ResolutionToJSON(value['resolution']),
        'buckets': value['buckets'],
        'resources': ((value['resources'] as Array<any>).map(SimpleDataRequestResourceToJSON)),
    };
}

